import { wrapWc } from 'brinejs/wrapper'
import '@ica-azure/ica-elements/IcaAlertMessage'

type IcaAlertMessageProps = React.JSX.IntrinsicElements['tgdb-ica-alert-message']

export const IcaAlertMessage = wrapWc<IcaAlertMessageProps & {
  onClose?: (e: CustomEvent) => void
}>('tgdb-ica-alert-message', ['close'])